import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
import enviro from 'enviro';
import { na1 } from 'hubspot-url-utils/hublets';
export const getBaseUrl = loadBalancer => {
  const hubletOverride = window.hubspot && window.hubspot.meetingsHubletOverride;
  return getFullUrl(loadBalancer || 'app', hubletOverride ? {
    hubletOverride
  } : {});
};
export const buildEmbeddedPaymentSessionUrl = (sessionId, email) => {
  const hubletOverride = window.hubspot && window.hubspot.meetingsHubletOverride || na1;
  if (!sessionId) {
    return null;
  }
  return enviro.isQa() ? `https://payments-${hubletOverride}.hubspotqa.com/payments/iframe/purchase/${sessionId}?referrer=PAYMENT_LINK_MEETING&email=${email}` : `https://payments-${hubletOverride}.hubspot.com/payments/iframe/purchase/${sessionId}?referrer=PAYMENT_LINK_MEETING&email=${email}`;
};
const isCustomDomain = checkoutUrlOrigin => {
  return enviro.isQa() ? !checkoutUrlOrigin.includes('hubspotqa.com') : !checkoutUrlOrigin.includes('hubspot.com');
};

/**
 *
 * @param checkoutUrl
 * @param email
 * parses out payment slug from checkoutUrl and builds a new one with the /iframe route
 * For instance https://payments-na1.hubspotqa.com/payments/NT_geLoqR?referrer=PAYMENT_LINK_MEETING
 */
export const buildEmbeddedCheckoutUrl = (checkoutUrl, email) => {
  const checkoutUrlObject = new URL(checkoutUrl);
  const checkoutUrlOrigin = checkoutUrlObject.origin;
  const parsedSlug = checkoutUrl.split('?')[0].split('payments/')[1];
  return isCustomDomain(checkoutUrlOrigin) ? `${checkoutUrlOrigin}/hs/payments/iframe/${parsedSlug}?referrer=PAYMENT_LINK_MEETING&email=${email}` : `${checkoutUrlOrigin}/payments/iframe/${parsedSlug}?referrer=PAYMENT_LINK_MEETING&email=${email}`;
};
export const unexpectedMessageHandler = message => {
  Raven.captureMessage('Unexpected Embedded Paid Meetings PostMessage ', {
    extra: {
      message: JSON.stringify(message)
    },
    fingerprint: ['PaymentIframe']
  });
};